import { render, staticRenderFns } from "./LoaderPayment.vue?vue&type=template&id=5603a39d&scoped=true&"
import script from "./LoaderPayment.vue?vue&type=script&lang=js&"
export * from "./LoaderPayment.vue?vue&type=script&lang=js&"
import style0 from "./LoaderPayment.vue?vue&type=style&index=0&id=5603a39d&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5603a39d",
  null
  
)

export default component.exports